import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
@JsonObject('model.QBFile')
export class QBFile extends AbstractModel {

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'contentType')
    contentType?: string;

    @JsonProperty(String, 'domain')
    domain?: string;

    @JsonProperty(String, 'fileName')
    fileName?: string;

    @JsonProperty(String, 'tempDownloadUri')
    tempDownloadUri?: string;
}
